// Barra lateral recolhida (só ícones) ou expandida. Estado partilhado entre a
// barra e o conteúdo (margem esquerda) e guardado no browser do utilizador.
import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "iead.sidebar.collapsed.v1";
const listeners = new Set();

function read() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

let collapsed = read();

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function setCollapsed(next) {
  collapsed = Boolean(next);
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
  } catch {
    /* ignore: modo privado / armazenamento bloqueado */
  }
  listeners.forEach((listener) => listener());
}

export default function useSidebarCollapsed() {
  const value = useSyncExternalStore(subscribe, () => collapsed, () => false);
  const toggle = useCallback(() => setCollapsed(!collapsed), []);
  return [value, toggle];
}
